import Validator from "@/validators/Validator";
import {ValidationRuleInput} from "@/declarations/ValidationRuleInput";
import i18n from "@/i18n";
import {isEmpty} from "@/helpers/functions_asi";

export class BreakDurationValidator extends Validator {

	private static readonly REASON_TOO_SHORT = 1;
	private static readonly REASON_TOO_LONG = 2;

	private readonly fromDateTime: Date | null = null;
	private readonly toDateTime: Date | null = null;

	public constructor(label: string, translateLabel: boolean = true, fromDateTime: string | Date | null, toDateTime: string | Date | null) {
		super(label, translateLabel);

		if (fromDateTime !== null){
			this.fromDateTime = fromDateTime instanceof Date ? fromDateTime : new Date(fromDateTime);
		}
		if (toDateTime !== null) {
			this.toDateTime = toDateTime instanceof Date ? toDateTime : new Date(toDateTime);
		}
	}

	protected validate(value: ValidationRuleInput): boolean | string {
		if (value === null || isEmpty(value.toString()) || this.fromDateTime === null || this.toDateTime === null) {
			return this.success();
		}

		const durationMinutes = (this.toDateTime.getTime() - this.fromDateTime.getTime()) / 60000;
		if (value > durationMinutes) {
			return this.fail(BreakDurationValidator.REASON_TOO_LONG);
		}
		if (durationMinutes > 6*60 && durationMinutes <= 9*60 && value < 15) {
			return this.fail(BreakDurationValidator.REASON_TOO_SHORT);
		}
		if (durationMinutes > 9*60 && value < 30) {
			return this.fail(BreakDurationValidator.REASON_TOO_SHORT);
		}

		return this.success();
	}

	protected validationFailedMessage(label: string, reason: number | null): string {
		if (reason === BreakDurationValidator.REASON_TOO_SHORT) {
			return i18n.t('validation.breakDurationTooShort', {field: label}).toString();
		} else {
			return i18n.t('validation.breakDurationTooLong', {field: label}).toString();
		}
	}

}
